<ng-content></ng-content>


<div id="NavMenu" class="left-panel " style="overflow: auto;">
    <nav id="WebNav" class="navbar navbar-light p-0">
        <div class="menu-left w-100" #menu id="menuItemID">
            <ul class="navbar-nav mb-100 px-0 pt-2">
                <ng-container *ngFor="let menu of items;let i = index">
                    <li class="nav-item" *ngIf="menu.visible">
                        <a *ngIf="menu.path === '/home' && !isESS" data-toggle="tooltip" (click)="onItemClick(menu)"
                            data-placement="right" title="{{menu.text}}"
                            class="nav-item nav-link d-flex align-items-end text-dark" [routerLinkActive]="['active']"
                            [routerLinkActiveOptions]="{exact: true}" routerLink="{{menu.path}}">
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home'">
                                home
                            </span>
                            <span class="pl-3 side-bar-text">{{menu.text}}</span>
                        </a>
                        <a *ngIf="menu.path === '/home' && isESS" data-toggle="tooltip" (click)="onItemClick(menu)"
                            data-placement="right" title="{{menu.text}}"
                            class="nav-item nav-link d-flex align-items-end text-dark" [routerLinkActive]="['active']"
                            routerLink="{{menu.path}}">
                            <span class="side-bar-icons ml-3">
                                <img [src]="menu.icon" alt="icon" class="image-dark mx-auto">
                                <img [src]="menu.icon_trans" alt="icon" class="image-white mx-auto">
                            </span>
                            <span class="pl-3 side-bar-text">{{menu.text}}</span>
                        </a>
                        <a *ngIf="menu.path !== '/home'" data-toggle="tooltip" (click)="onItemClick(menu)"
                            data-placement="right" title="{{menu.text}}" [id]="menu.path"
                            class="nav-item nav-link d-flex align-items-end text-dark" [routerLinkActive]="['active']"
                            routerLink="{{menu.path}}">
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/ESS-Home'">
                                home
                            </span>
                            <span id="My-Details" class="material-symbols-outlined ml-3"
                                *ngIf="menu.path == '/My-Details'">
                                person
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Requirements'">
                                format_list_bulleted
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Financials'">
                                currency_rupee
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Assets'">
                                web_asset
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Team-Members'">
                                people
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Employee-Directory'">
                                person_search
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Org-Chart'">
                                person_search
                            </span>
                            <span class="material-symbols-outlined  ml-3" *ngIf="menu.path == '/HR-Activities'">
                                perm_contact_calendar
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Personal-Info'">
                                manage_accounts
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Profile-Photo'">
                                person
                            </span>

                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Address-Info'">
                                location_on
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Family-info'">
                                family_restroom
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Education-info'">
                                school
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Employement-info'">
                                badge
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Bank-Details'">
                                account_balance
                            </span>
                            <span class="material-symbols-outlined ml-3"
                                *ngIf="menu.path == '/home/consultant-documentation'">
                                folder
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/References'">
                                quick_reference_all
                            </span>
                            <span class="material-symbols-outlined ml-3"
                                *ngIf="menu.path == '/home/Onboarding-Declaration'">
                                edit_note
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/skill-details'">
                                settings
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/My-Document'">
                                files
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/My-Queries'">
                                help_center
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/FAQ-Template'">
                                quiz
                            </span>
                            <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Social'">
                                share
                            </span>
                            <span class="pl-3 side-bar-text">{{menu.text}}</span>
                        </a>
                    </li>
                </ng-container>
            </ul>
        </div>
    </nav>
</div>



<div class="mobile-panel " style="overflow: auto;">
    <nav id="MobileNav" class="navbar">
        <div class="collapse navbar-collapse" id="navbarSupportedContent">

            <ul class="navbar-nav mb-100 px-0 pt-2">
                <li class="nav-item" *ngFor="let menu of items;let i = index" [ngClass]="{'d-none':!menu.visible}">
                    <a *ngIf="menu.path === '/home' && !isESS" data-toggle="tooltip" (click)="onItemClick(menu)"
                        data-placement="right" title="{{menu.text}}" class="nav-link d-flex align-items-end text-dark"
                        [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}"
                        routerLink="{{menu.path}}" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home'">home</span>
                        <span class="pl-3 side-bar-text">{{menu.text}}</span>
                    </a>
                    <a *ngIf="menu.path === '/home' && isESS" data-toggle="tooltip" (click)="onItemClick(menu)"
                        data-placement="right" title="{{menu.text}}" class="nav-link d-flex align-items-end text-dark"
                        [routerLinkActive]="['active']" routerLink="{{menu.path}}" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span class="side-bar-icons ml-3">
                            <img [src]="menu.icon" alt="icon" class="image-dark mx-auto">
                            <img [src]="menu.icon_trans" alt="icon" class="image-white mx-auto">
                        </span>
                        <span class="pl-3 side-bar-text">{{menu.text}}</span>
                    </a>
                    <a *ngIf="menu.path !== '/home'" data-toggle="tooltip" (click)="onItemClick(menu)"
                        data-placement="right" title="{{menu.text}}"
                        class="nav-item nav-link d-flex align-items-end text-dark" [routerLinkActive]="['active']"
                        routerLink="{{menu.path}}" type="button" data-toggle="collapse"
                        data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent"
                        aria-expanded="false" aria-label="Toggle navigation">
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/ESS-Home'"> home </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/My-Details'"> person </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Requirements'">
                            format_list_bulleted
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Financials'">currency_rupee
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Assets'"> web_asset </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Team-Members'"> people
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Employee-Directory'">
                            person_search
                        </span>
                        <span class="material-symbols-outlined  ml-3" *ngIf="menu.path == '/HR-Activities'">
                            perm_contact_calendar </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Personal-Info'">
                            manage_accounts
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Profile-Photo'">
                            person
                        </span>

                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Address-Info'">
                            location_on
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Family-info'">
                            family_restroom
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Education-info'">
                            school
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Employement-info'">
                            badge
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/Bank-Details'">
                            account_balance
                        </span>
                        <span class="material-symbols-outlined ml-3"
                            *ngIf="menu.path == '/home/consultant-documentation'">
                            folder
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/References'">
                            quick_reference_all
                        </span>
                        <span class="material-symbols-outlined ml-3"
                            *ngIf="menu.path == '/home/Onboarding-Declaration'">
                            edit_note
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/home/skill-details'">
                            settings
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/My-Document'">
                            files
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/My-Queries'">
                            help_center
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/FAQ-Template'">
                            quiz
                        </span>
                        <span class="material-symbols-outlined ml-3" *ngIf="menu.path == '/Social'">
                            share
                        </span>
                        <span class="pl-3 side-bar-text">{{menu.text}}</span>
                    </a>
                </li>
            </ul>

        </div>
    </nav>
</div>